import {
  SlideAction,
  SlideLayout,
  ViewMode
} from '@gripp/shared-ui';
import { useNavigate } from 'react-router-dom';
import { ActivityEditColumn } from './activityEditColumn';
import { ActivityReassignColumn } from './activityReassignColumn';

export const ActivityReassign = () => {
  const navigate = useNavigate();

  const leftColumn = {
    title: 'issue.menu.edit',
    mainComponent: (
      <ActivityEditColumn />
    ),
    onBackButtonPress: () => {
      navigate('../..', { 
        relative: 'path',
        state: { skipAutoSelect: true }
      });
    },
    backButtonTransition: SlideAction.PREV,
    showBackButton: true,
    disableScroll: true,
  };

  const rightColumn = {
    title: 'issue.menu.reassign',
    mainComponent: (
      <ActivityReassignColumn />
    ),
    onBackButtonPress: () => {
      navigate('..', { 
        relative: 'path'
      });
    },
    backButtonTransition: SlideAction.PREV,
    showBackButton: true,
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
